import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../../services/system/storage.service';
import { CouriersService } from '../../../../services/courier-services/couriers.service';
import { CourierServiceModel, PackageOption } from '../../../../models/inModels/MarketPlaceModel';

@Component({
  selector: 'app-edit-courier',
  templateUrl: './edit-courier.component.html',
})
export class EditCourierComponent implements OnInit {
  model: CourierServiceModel;
  loading = false;
  error: Message[];
  messages: Message[];
  id;
  items: PackageOption[] = [];
  constructor(
    public storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private service: CouriersService,) {
    this.model = new CourierServiceModel();
  }

  ngOnInit() {
    this.loading = true;
    this.id = this.route.snapshot.params.Id;
    this.service.get(this.id).then(
      res => {
        this.model = new CourierServiceModel(res);
        this.items = this.model.PackageOptions;
        console.log("Courier to edit", this.model);
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.messages = [];
        this.messages.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  goBack(): void {
    this.router.navigate(['/marketplace/courier-services']);
  }

  save() {
    this.loading = true;
    this.service.update(this.model).then(
      res => {
        this.model = new CourierServiceModel(res);
        this.loading = false;
        this.goBack();
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  edit(option: PackageOption) {
    this.router.navigate(['marketplace/courier-services/package-option/edit', option.Id]);
  } 

  deletePackage(option: PackageOption) {
    this.service.deletePackageOption(option.Id.toString()).then(
      res => {
        this.items = this.items.filter(i => i.Id !== option.Id);
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  } 

  handleBackgroundImage(event): void {
    var result = this.storageService.handleSuccess(event);
    this.model.LogoId = result.PublicId;
    this.loading = false;
  }
    
  handleError(event): void {
    this.loading = false;
    this.error = [];
    this.storageService.handleError(event, this.error);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/courier-services/edit/edit-courier/edit-courier.component.ts